// F-1 · Recompute guard — computed is a CACHE that is NEVER trusted from
// storage: it is re-derived on every render/load via computeLift, and an
// engineVersion mismatch forces recalculation (blueprint Phase F).
import { computeLift, ENGINE_VERSION } from './riggingCalculations.v2';
import type { LiftDetail, LiftComputed } from '@/types/planData';

/** True when a stored computed cache cannot be trusted (missing/mismatched version or stale inputs). */
export function needsRecompute(lift: LiftDetail): boolean {
  return (
    !lift.computed ||
    lift.computed.engineVersion !== ENGINE_VERSION
  );
}

/**
 * Recompute a lift's forces fresh from geometry/hardware/loading inputs.
 * Never reads numbers from storage — storage computed is discarded wholesale.
 * Refused configs return the refusal-bearing computed (no numeric forces).
 */
export function recomputeComputed(lift: LiftDetail): LiftComputed | null {
  try {
    return computeLift(lift);
  } catch {
    return null;
  }
}
